import { takeEvery } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { loadDataAction,loadDataDoneAction, loadDataErrorAction } from 'modules/app/actions';
import { getUnits } from '../actions';
import { GET_UNITS } from '../constants/actionTypes';
import * as api from '../repository';


function *_fetchUnits(action) {
    const {vtrac} = action;
    yield put(loadDataAction('units'));
    try {
        const units =  yield call(api.getVisitUnits(vtrac));
        yield put(getUnits.success({units,vtrac}));
        yield put(loadDataDoneAction('units'));
    } catch (error) {
        yield put(getUnits.error(error));
        yield put(loadDataErrorAction('units', {response: error.response}, action));
    }
}

export function *fetchUnits() {
    yield takeEvery(GET_UNITS.REQUEST, _fetchUnits);
}
